package com.macrofocus.nastac.components

import emotion.react.css
import i18next.useTranslation
import mui.material.TooltipPlacement
import react.FC
import react.PropsWithChildren
import react.ReactNode
import react.dom.html.ReactHTML
import web.cssom.MarginLeft

external interface LogoProps : PropsWithChildren,mui.system.PropsWithSx {
    var version: String
    var logo: String
    var height: Double?
    var marginLeft: MarginLeft?
    var marginTop: MarginLeft?
    var tooltip: ReactNode?
}

val Logo = FC<LogoProps> { props ->
    val (t, _) = useTranslation()

    mui.material.Tooltip {
        if(props.tooltip != null) {
            title = props.tooltip!!
        } else {
            if(props.version != null) {
                title = ReactNode("Version ${props.version}")
            } else {
                title = ReactNode("ETH Zurich")
            }

        }
        placement = TooltipPlacement.bottomEnd

        ReactHTML.img {
            css {
                if(props.marginLeft != null) {
                    marginLeft = props.marginLeft
                }
                if(props.marginTop != null) {
                    marginTop= props.marginTop
                }
        }
            src = props.logo
            height = if(props.height != null) props.height else 36.0
        }
    }
}